module.exports = __webpack_public_path__ + "img/img_case_index_03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/case/img_case_index_03.jpg
// module id = 785
// module chunks = 0